import { useStyle } from "./style";
import { SvgIcon, Theme, Typography } from "@mui/material";
import * as React from "react";

interface IParams {
    svgIcon: React.ElementType;
    title: string;
    description: string;
    isCompactLayout?: boolean;
    getIconColor?(theme: Theme): string;
    getBackgroundColor?(theme: Theme): string;
}

export const HomeBroadbandWhyBlock = (props: IParams) => {
    const { svgIcon, title, description, isCompactLayout = false, getBackgroundColor, getIconColor } = props;

    const { classes } = useStyle({
        isMobileOrTablet: isCompactLayout,
        getBackgroundColor,
        getIconColor,
    });

    return (
        <div className={classes.whyBlock}>
            <div className={classes.iconWrapper}>
                <SvgIcon className={classes.iconSecondary} component={svgIcon} inheritViewBox />
            </div>
            <div className={classes.marketingContent}>
                <Typography align="center" className={classes.marketingTitle} variant="h3">
                    {title}
                </Typography>
                <Typography align="center" className={classes.marketingDescription} variant="normal">
                    {description}
                </Typography>
            </div>
        </div>
    );
};
